module.exports = __webpack_public_path__ + "media/images/admin/icons/play-circle-dcf880c0306a61d5aa81ec2960fa6e90.svg";